import { render, staticRenderFns } from "./Info_General.vue?vue&type=template&id=4c818b72&scoped=true&"
import script from "./Info_General.vue?vue&type=script&lang=js&"
export * from "./Info_General.vue?vue&type=script&lang=js&"
import style0 from "./Info_General.vue?vue&type=style&index=0&id=4c818b72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c818b72",
  null
  
)

export default component.exports